import React from 'react'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'
import mirror from '@vio/atlas/src/utils/mirror'

type OnButtonClick = (e: React.SyntheticEvent<Element, Event>) => void

interface Props {
  /** Callback fired when the back button is clicked */
  onClick?: OnButtonClick
  /** Custom icon for the back button. Defaults to a (RTL-mirrored) ChevronLeft. */
  icon?: React.ReactNode
}

const StyledBackButton = styled(Button)`
  ${mirror()}
`

/**
 * Back button for the NavBar `startContent`. Replaces the back button that the
 * legacy `Header`/`CompactHeader` rendered internally.
 */
export const NavBarBackButton = ({
  onClick,
  icon = <Icon name="ChevronLeft" />
}: Props) => (
  <StyledBackButton
    hasTouchArea
    size="md"
    variant="ghost"
    iconStart={icon}
    onClick={onClick}
    dataId="BackButton"
  />
)
